module.exports = __webpack_public_path__ + "img/ledger-live-setting-step-six.5603fc07.png";